import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import type { AuthTokens, User } from '@sss/types';
import { api } from '../lib/api';
import { setSession } from '../store/authSlice';
import OAuthButtons from '../components/Auth/OAuthButtons';

export default function RegisterPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      const result = await api<{ user: User; tokens: AuthTokens }>('/v1/auth/register', {
        method: 'POST',
        auth: false,
        body: JSON.stringify({ email, password }),
      });
      dispatch(
        setSession({
          user: result.user,
          accessToken: result.tokens.access.token,
          refreshToken: result.tokens.refresh.token,
        }),
      );
      navigate('/account');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Registration failed');
    }
  }

  return (
    <main style={{ maxWidth: 360, margin: '4rem auto', fontFamily: 'system-ui, sans-serif' }}>
      <h1>Create an account</h1>
      <form onSubmit={onSubmit}>
        <label>
          Email
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </label>
        <label>
          Password
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </label>
        <button type="submit">Sign up</button>
      </form>
      <OAuthButtons />
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <p>
        Already have an account? <Link to="/login">Sign in</Link>
      </p>
    </main>
  );
}
